import React from 'react'

import { Card, Grid, Typography, CardContent, CardHeader, Button } from '@material-ui/core'
// import AppraisalHeader from '../../Assignment/CommonContent/IndividualHeader/IndividualHeader'
import Spinner from '../../../UI/Spinner/Spinner'
import CardList from './CardList/CardList'
import FilterBar from '../../../FilterBar/FilterBar'
import PageInfo from '../../../PageInfo/PageInfo'

import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const AppraisalContent = ({
  companyName,
  records,
  selected,
  recordSelected,
  selectAllClicked,
  actionClicked,
  selectDisabled,
  pagination,
  pageChanged,
  perPageChanged,
  filterButtonClicked,
  editButtonClicked,
  filtered,
  pageLoading,
  pagePermission,
  appraisalType,
  translate
}) => {
  const theme = useTheme()
  const MobileVertical = useMediaQuery(theme.breakpoints.down('xs'))

  let content = <Spinner />
  if (!pageLoading) {
    content = (
      <CardList
        records={records}
        selected={selected}
        recordSelected={recordSelected}
        selectDisabled={selectDisabled}
        pagination={pagination}
        pageChanged={pageChanged}
        perPageChanged={perPageChanged}
        editButtonClicked={editButtonClicked}
        filtered={filtered}
        pagePermission={pagePermission}
        appraisalType={appraisalType}
      />
    )
  }
  let companyInfo = null

  if (companyName) {
    companyInfo = (
      <Typography variant={'h6'}>
        {translate('companyInfo')} : {companyName}
      </Typography>
    )
  }

  const actionButtonDisabled = selectDisabled || !selected.length
  const selectAllDisabled = selectDisabled || !records.length

  return (
    <Card>
      <CardHeader title={<PageInfo pageTranslateKey={'appraisal'} />} />
      <CardContent>
        {MobileVertical ? (
          <>
            <Grid container justify={'space-between'} alignItems={'center'}>
              <Grid item>{companyInfo}</Grid>
            </Grid>
            <Grid container item xs sm spacing={1}>
              <Grid container item justify={'flex-end'} alignItems={'center'} spacing={1} xs>
                <Grid item>
                  <Button
                    style={{ height: 36 }}
                    variant={'outlined'}
                    onClick={selectAllClicked}
                    disabled={selectAllDisabled}>
                    {translate('selectAll')}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    style={{ height: 36 }}
                    variant={'outlined'}
                    onClick={actionClicked}
                    disabled={actionButtonDisabled}>
                    {translate('action')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item>
                <FilterBar companyName={companyName} buttonClicked={filterButtonClicked} />
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Grid container justify={'space-between'} alignItems={'center'}>
              <Grid item>{companyInfo}</Grid>
              <Grid container item xs sm spacing={1}>
                <Grid container item justify={'flex-end'} alignItems={'center'} spacing={1} xs>
                  <Grid item>
                    <Button
                      style={{ height: 36 }}
                      variant={'outlined'}
                      onClick={selectAllClicked}
                      disabled={selectAllDisabled}>
                      {translate('selectAll')}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      style={{ height: 36 }}
                      variant={'outlined'}
                      onClick={actionClicked}
                      disabled={actionButtonDisabled}>
                      {translate('action')}
                    </Button>
                  </Grid>
                </Grid>
                <Grid item>
                  <FilterBar companyName={companyName} buttonClicked={filterButtonClicked} />
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </CardContent>
      {content}
    </Card>
  )
}

export default AppraisalContent
